<template>
  <div>
    <div v-if="!isSuccess">
      <div class="d-flex align-items-center pb-3">
        <b-avatar src="https://i.pravatar.cc/300" text="JD" size="2.5rem" class="mr-3" />
        <div>
          <div><strong>John Doe</strong></div>
        </div>
      </div>
      <div class="pb-2">
        <b-form-textarea
          id="contentShareText"
          v-model="contentShareText"
          rows="5"
          max-rows="5"
          :disabled="!(image || companyImage) || isLoading"
          />
        <b-alert class="mt-2" v-if="errorText" variant="danger" show>
          {{ errorText }}
        </b-alert>
      </div>

      <content-share-link
        v-if="image || companyImage"
        :title="title"
        :url="url || '-'"
        :imageURL="image || companyImage"
        :loading="false"
      />
      <b-alert
        v-else
        variant="warning"
        show
      >
        Couldn't find an image associated with this job or company. Please make sure you upload one (not bigger than 5Mb) before sharing to LinkedIn.
      </b-alert>

      <b-row class="pr-3 pt-4 justify-content-end">
        <b-button type="submit" variant="primary" :disabled="!(image || companyImage) || isLoading" @click.prevent="sumbmitPost">
          <div class="d-flex justify-content-center align-items-center">
            <span>Post to LinkedIn</span>
            <b-spinner class="ml-2" v-if="isLoading" variant="primary" label="Loading" small />
          </div>
        </b-button>
      </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col class="p-4 text-center">
          <h2>Congrats! 🎉</h2>
          <p>We've succesfully created your LinkedIn post.</p>
          <p>
            Click the following link to see it in your activity feed:
            <a
              href="https://www.linkedin.com/in/me/recent-activity/all/"
              target="_blank">
              https://www.linkedin.com/in/me/recent-activity/all
            </a>
          </p>
          <p>
          </p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import ContentShareLink from '@/components/content-share/content-share-editor/ContentShareLink';
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    job: {
      type: Object,
    },
    campaignID: {
      type: String,
      default: null,
    },
  },
  components: {
    ContentShareLink,
  },
  computed: {
    ...mapRoot([ 'company' ]),
    companyImage() {
      return this.company && this.company.siteBranding && this.company.siteBranding.socialImage && this.company.siteBranding.socialImage.fileLocation ? this.company.siteBranding.socialImage.fileLocation : null;
    },
  },
  data() {
    const { job } = this;
    const { image, title, url } = job || {};

    return {
      contentShareText: '🚀 Excited to share this content! 🌟',
      errorText: null,
      isSuccess: false,
      isLoading: false,
      image,
      title,
      url
    };
  },
  watch: {
    contentShareText() {
      if (this.contentShareText.length > 3) {
        this.errorText = null;
      }
    },
  },
  methods: {
    async sumbmitPost() {
      this.errorText = null;

      const { contentShareText, campaignID, job } = this;

      if (!contentShareText || contentShareText.length < 4) {
        this.errorText = 'Make sure your text is at least 3 characters.';
      }

      const CreateLinkedInPost = gql`
        mutation CreateLinkedInPost($input: CreateLinkedInPostInput!) {
          createLinkedInPost(input: $input) {
            postURN
            status
            errorMessage
          }
        }
      `;

      try {
        this.isLoading = true;
        const { data } = await this.$apollo.mutate({
          mutation: CreateLinkedInPost,
          variables: {
            input: {
              campaignID,
              entity: { id: job.id, type: 'job' },
              shareText: contentShareText
            }
          },
        });
        const { createLinkedInPost: response } = data || {};

        if (!response || response.status === 'ERROR') {
          // Display only errors related to asset validation
          const errMsg = response.errorMessage && response.errorMessage.startsWith('Asset') ? response.errorMessage : 'Sorry, your request has failed.';

          this.$notification({
            message: errMsg,
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            title: 'Post creation failed'
          });
        }
        if (response && response.status === 'SUCCESS') {
          this.$emit('track', { channel: 'linkedin-api' });
          this.isSuccess = true;
        }
      } catch (error) {
        this.$notifyErr(error);
      } finally {
        if (this.$router.history && this.$router.history.current && this.$router.history.current.query && this.$router.history.current.query.callback) {
          this.$router.push(this.$router.history.current.path);
        }
        this.isLoading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/content-share/LinkedInJobsPostEditor.vue